import { useEffect, useState } from "react";
import "../../components/css/landingpage.css";
import Button from "../common/Button";
import Footer from "../common/Footer";
import Navbar from "../common/Navbar";
import { Link } from "react-router-dom";


function LandingPage() {

  const [activeTab, setActiveTab] = useState("why");

  useEffect(() => {
    /* SCROLL REVEAL */
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    elements.forEach((el) => observer.observe(el));

    /* PARTICLES */
    const particles = document.querySelectorAll(".particle");
    particles.forEach((p) => {
      const duration = 5 + Math.random() * 5;
      p.style.left = Math.random() * 100 + "%";
      p.style.top = Math.random() * 100 + "%";
      p.style.animation = `floatUp ${duration}s linear infinite`;
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="landing-page" id="home">
      <Navbar />

      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-bg">
          {[...Array(30)].map((_, i) => (
            <div key={i} className="particle" />
          ))}
        </div>

        <div className="hero-content reveal">
          <h1 className="type-reveal">
            <span className="line line-1">
              Driving Innovation Across
            </span>
            <span className="line line-2">
             Agriculture & Automation
              {/* Energy, Mobility & Automation */}
            </span>
          </h1>

          <p className="reveal">
            NXSA builds intelligent embedded systems and IoT solutions that power innovation<br /> in Agriculture Automation.
            {/* NXSA builds intelligent embedded systems and IoT solutions that power innovation<br /> in Agriculture, Electric Mobility, Renewable Energy, and Industrial Automation. */}

          </p>
          <div className="cta reveal">
            <Button text="Power Up" />
          </div>
        </div>

        <div className="info-card card-left reveal ">
          <h4>Concept to Product Development</h4>
          <p>We turn innovative ideas into reliable and scalable technology solutions.</p>

        </div>

        <div className="info-card card-right reveal">
          <h4>Built for Scalable Technology</h4>
          <p>Future-ready systems built for reliability, performance, and scalability.</p>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="about-us" id="about">
        <div className="about-text reveal">

          <div className="about-subtitle">
            <img
              src="/icon/our_product_icon.png"
              alt="About Us icon"
              className="about-icon"
            />
            <span className="about-subtitle-text">About Us</span>
          </div>

          <h2>Smart Solutions.<br /> Built Sustainable.</h2>

          <p>
            NXSA is a technology-driven product company building smart, reliable, <br />
            and scalable solutions with real-world impact. We specialize in embedded systems, electronics, and software development, delivering innovative technology across Agriculture 
            Automation. Our focus is to transform advanced technology into practical solutions that improve efficiency, automation, and sustainability. From concept to deployment, we build future-ready systems designed to perform reliably in real-world environments.

            {/* and scalable solutions with real-world impact. We specialize in embedded systems, electronics, and software development, delivering innovative technology across Agriculture, Electric Mobility, Renewable Energy, and <br /> */}

          </p>
        </div>

        <div className="about-images reveal delay-2">
          <img src="/images/about_us.png" alt="about us" />
        </div>
      </section>


      {/* ================= OUR PRODUCTS ================= */}
      <section className="nxsa-products" id="products">
        <div className="nxsa-products-header">
          <div className="products-subtitle">
            <img src="/icon/our_product_icon.png" alt="Our Products" />
            <span>Our Products</span>
          </div>

          <h2>
            Empowerment Through
            <br />
            Intelligence and Reliability
          </h2>

        </div>


        <div className="nxsa-products-grid">

          {/* AGRICULTURE */}
          <Link to="" className="nxsa-product-card">
            <div className="product-icon">
              <img src="/icon/krushi_icon.png" alt="Krushi" />
            </div>
            <h4>Agriculture</h4>
            <p>
              NXSA empowers farmers with Krushi, enabling smarter farming through intelligent monitoring.
            </p>
            <span className="see-more">See More <span>→</span></span>
            <div className="product-image">
              <img src="/images/product_krushi.png" alt="Krushi" />
            </div>
          </Link>
{/* --------------------------------------------------------------------- */}
          {/* ELECTRIC MOBILITY */}
          {/* <Link to="" className="nxsa-product-card">
            <div className="product-icon">
              <img src="/icon/ev_icon.png" alt="EV" />
            </div>
            <h4>Electric Mobility</h4>
            <p>
              Empowering electric mobility through intelligent, connected systems.
            </p>
            <span className="see-more">See More <span>→</span></span>
            <div className="product-image">
              <img src="/images/product_ev.png" alt="EV" />
            </div>
          </Link> */}

          {/* RENEWABLE ENERGY */}
          {/* <Link to="" className="nxsa-product-card">
            <div className="product-icon">
              <img src="/icon/energy_icon.png" alt="Energy" />
            </div>
            <h4>Renewable Energy</h4>
            <p>
              Empowering renewable energy with smart monitoring solutions.
            </p>
            <span className="see-more">See More <span>→</span></span>
            <div className="product-image">
              <img src="/images/product_energy.png" alt="Energy" />
            </div>
          </Link> */}

          {/* HOME AUTOMATION */}
          {/* <Link to="" className="nxsa-product-card">
            <div className="product-icon">
              <img src="/icon/home_auto_icon.png" alt="Home Automation" />
            </div>
            <h4>Home Automation</h4>
            <p>
              NXSA empowers homes with intelligent and connected automation solutions.
            </p>
            <span className="see-more">See More <span>→</span></span>
            <div className="product-image">
              <img src="/images/product_home.png" alt="Home Automation" />
            </div>
          </Link> */}

        </div>


      </section>


      {/* ================= OUR SERVICES ================= */}
      <section className="nxsa-services" id="services">
        <div className="nxsa-services-inner">

          {/* TOP CONTENT */}
          <div className="services-top">
            <div className="services-top-left">
              <div className="services-subtitle">
                <img
                  src="/icon/krushi_icon.png"
                  alt="Our Services"
                  className="services-subtitle-icon"
                />
                <span>Our Services</span>
              </div>

              <h2>
                Smart Technology.<br />
                Real-World Impact.
              </h2>
            </div>

          </div>

          {/* SERVICE CARDS */}
          {/* SERVICE CARDS */}
          <div className="services-cards">
            {[
              {
                title: "Product Architecture & System Design",
                image: "/Services/Product_Architecture_&_System_Design.png",
              },
              {
                title: "PCB Design & Hardware Engineering",
                image: "/Services/PCB_Design_&_Hardware_Engineering.png",
              },
              {
                title: "Embedded Firmware Engineering",
                image: "/Services/Embedded_Firmware_Engineering.png",
              },
              {
                title: "IoT & Cloud Systems Integration",
                image: "/Services/IoT_&_Cloud_Systems_Integration.png",
              },
              {
                title: "Software Engineering & Development",
                image: "/Services/Software_Engineering_&_Development.png",
              },
              {
                title: "End-to-End Product Engineering",
                image: "/Services/End_to_End_Product_Engineering.png",
              },
            ].map((item, i) => (
              <div className="service-card" key={i}>
                <div className="service-icon">
                  <img src={item.image} alt={item.title} loading="lazy" />
                </div>
                <p className="service-title">{item.title}</p>
              </div>
            ))}
          </div>

        </div>
      </section>



      <section className="nxsa-why">
        <div className="nxsa-why-container">

          {/* LEFT IMAGE */}
          <div className="nxsa-why-image">
            <img src="/images/battery_image.png" alt="Why Choose NXSA" />
          </div>

          {/* RIGHT CONTENT */}
          <div className="nxsa-why-content">

            {/* TABS */}
            <div className="why-tabs">
              <button
                className={`why-tab ${activeTab === "why" ? "active" : ""}`}
                onClick={() => setActiveTab("why")}
              >
                <img src="/icon/why_choose_us.png" alt="Why Choose Us" className="tab-icon" />
                Why Choose Us?
              </button>

              <button
                className={`why-tab ${activeTab === "mission" ? "active" : ""}`}
                onClick={() => setActiveTab("mission")}
              >
                <img src="/icon/our_mission.png" alt="Our Mission" className="tab-icon" />
                Our Mission
              </button>

              <button
                className={`why-tab ${activeTab === "vision" ? "active" : ""}`}
                onClick={() => setActiveTab("vision")}
              >
                <img src="/icon/vision.png" alt="Our Vision" className="tab-icon" />
                Our Vision
              </button>

            </div>

            {/* TAB CONTENT */}
            {activeTab === "why" && (
              <div className="why-tab-content">
                <h2>Innovative Technology<br />

                  Into Practical Solutions</h2>

                <p>
                  NXSA builds smart, reliable technology solutions that improve efficiency,
                  automation, and sustainability across Agriculture Automation.
                  {/* automation, and sustainability across Agriculture, Electric Mobility,
                  Renewable Energy, and Home Automation. */}
                </p>

                <ul className="why-list">
                  <li>Real-world impact</li>
                  <li>Industry-driven innovation</li>
                  <li>Simple and efficient technology</li>
                  <li>Reliable and scalable solutions</li>

                </ul>
              </div>
            )}

            {activeTab === "mission" && (
              <div className="why-tab-content">
                <h2>
                  Smart Technology.<br />
                  Real-World Impact.
                </h2>

                <p>
                  NXSA develops smart technology solutions that automate operations,
                  improve efficiency, and reduce energy use across Agriculture Automation.
                  {/* Mobility, Renewable Energy, and Home Automation. */}
                </p>

                <ul className="why-list">
                  <li>Solving real-world challenges</li>
                  <li>Improving productivity and efficiency</li>
                  <li>Scalable and future-ready solutions</li>
                  <li>Supporting sustainable innovation</li>
                </ul>
              </div>
            )}

            {activeTab === "vision" && (
              <div className="why-tab-content">
                <h2>Shaping a Smarter <br /> Sustainable Future</h2>

                <p>
                  Our vision is to build intelligent technology that creates a smarter,
                  more sustainable future. NXSA focuses on delivering reliable and
                  innovative solutions across Agriculture Automation. 
                  {/* Mobility, Energy, and Automation. */}
                </p>

                <ul className="why-list">
                  <li>Smarter everyday living</li>
                  <li>Sustainable innovation</li>
                  <li>Reliable and trusted technology</li>
                  <li>Scalable solutions for the future</li>
                </ul>
              </div>
            )}

          </div>
        </div>
      </section >



      {/* ✅ FOOTER (ADDED HERE) */}
      < Footer />


    </div >
  );
}

export default LandingPage;
